import { render, staticRenderFns } from "./AppointmentBtn.vue?vue&type=template&id=c73e2422&scoped=true"
import script from "./AppointmentBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./AppointmentBtn.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AppointmentBtn.vue?vue&type=style&index=0&id=c73e2422&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73e2422",
  null
  
)

export default component.exports